<template>
  <div class="container">
    <head-nav-bar title="办理健康卡" :fixed="true" />
    <div class="mt-header-nav">
      <van-tabs v-model="activeTab">
        <van-tab title="办理健康卡">
          <van-cell-group>
            <van-field
              v-model="form.name"
              required
              clearable
              :readonly="showSmsCheck"
              label="真实姓名："
              placeholder="请输入真实姓名"
            />
            <van-field
              v-model="form.identityNo"
              label="身份证号："
              :readonly="showSmsCheck"
              clearable
              placeholder="请输入身份证号码"
            />
            <van-field
              v-if="activeTab === 0 && showSmsCheck"
              readonly
              v-model="form.mobilePhone"
              label="手机号码："
              clearable
            />
            <van-field
              v-if="activeTab === 0 && showSmsCheck"
              v-model="form.smsCode"
              placeholder="请输入验证码"
              label="短信验证码："
              clearable
            >
              <template #button>
                <van-button size="small" v-if="smsTimer > 0">
                  {{ smsTimer }}秒后重新获取</van-button
                >
                <van-button
                  size="small"
                  type="primary"
                  v-else
                  @click="getSmsCode"
                  >获取验证码</van-button
                >
              </template>
            </van-field>
          </van-cell-group>
        </van-tab>
        <van-tab title="就诊卡绑定">
          <van-cell-group>
            <van-field
              v-model="form.name"
              required
              clearable
              label="真实姓名："
              placeholder="请输入真实姓名"
            />
            <van-field
              v-model="form.cardNo"
              class="readonly"
              label="就诊卡号："
              clearable
              placeholder="请输入就诊卡号"
            />
            <van-field
              v-if="activeTab === 1 && showSmsCheck"
              readonly
              v-model="form.mobilePhone"
              label="手机号码："
              clearable
            />
            <van-field
              v-if="activeTab === 1 && showSmsCheck"
              v-model="form.smsCode"
              placeholder="请输入验证码"
              label="短信验证码："
              clearable
            >
              <template #button>
                <van-button size="small" v-if="smsTimer > 0">
                  {{ smsTimer }}秒后重新获取</van-button
                >
                <van-button
                  size="small"
                  type="primary"
                  v-else
                  @click="getSmsCode"
                  >获取验证码</van-button
                >
              </template>
            </van-field>
          </van-cell-group>
        </van-tab>
      </van-tabs>
      <div class="box" style="margin-top: 0.5rem">
        <van-button
          v-if="!showSmsCheck"
          type="info"
          block
          :loading="loading"
          @click="onSubmit"
          style="margin-bottom: 0.5rem"
          >{{
            this.sysParams.enabledHealthCard ? "手工填写办卡" : "下一步"
          }}</van-button
        >
        <van-button
          v-if="
            this.sysParams.enabledHealthCard && activeTab === 0 && !showSmsCheck
          "
          type="info"
          block
          :loading="loading"
          @click="onHealthCardSubmit"
          >通过电子健康卡办卡</van-button
        >
        <van-button
          v-if="showSmsCheck"
          type="info"
          block
          :loading="loading"
          @click="onHealthCardConfirmSubmit"
          >下一步</van-button
        >
        <!-- <van-button
          v-if="activeTab === 1 && !showSmsCheck"
          type="info"
          block
          :loading="loading"
          @click="onSubmit"
          style="margin-bottom: 0.5rem"
          >下一步</van-button
        > -->
      </div>
    </div>
  </div>
</template>

<script>
import { Card, Dialog, Tab, Tabs, Field, Cell, CellGroup, Button } from "vant";
export default {
  components: {
    [Card.name]: Card,
    [Dialog.Component.name]: Dialog.Component,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
  },
  data() {
    return {
      activeTab: 0,
      loading: false,
      info: {},
      showSelectAddType: false,
      form: {
        name: "",
        identityNo: "",
        mobilePhone: "",
      },
      showSmsCheck: false,
      sysParams: {},
      smsTimer: 0,
      smsTimerInterval: null,
      healthCardResult: {},
      checkSmsAfterHandleMode: "add", //add:添加就诊人，edit:绑定就诊人
    };
  },
  created() {
    this.$post("GetWxSystemParameterInfo", {}).then((res) => {
      this.sysParams = res.data;
    });
  },
  destoryed() {
    clearInterval(this.smsTimerInterval);
  },
  methods: {
    toInfo(item) {
      this.$router.push({
        name: "userContactCreatCardMenu",
        query: {
          Id: item.Id,
        },
      });
    },
    toAddCard() {
      this.showSelectAddType = true;
    },
    onAddTypeClick(type) {
      this.$router.push({
        name: "userContactEdit",
        query: {
          type,
        },
      });
    },
    onSubmit() {
      if (!this.form.name) {
        this.$notify("请填写真实姓名");
        return;
      }
      if (!this.form.name) {
        this.$notify("请填写身份证号码");
        return;
      }
      const params = {
        name: this.form.name,
      };
      if (this.activeTab == 0) {
        params.identityNo = this.form.identityNo;
        this.checkPersonInfo(params);
      } else {
        params.diagnosisCardNo = this.form.cardNo;
        this.$post("VerifyCardBind", {
          DiagnosisCardNo: params.diagnosisCardNo,
        }).then((res) => {
          if (res.data) {
            //已绑定过的卡号
            Dialog.alert({
              title: "提示",
              message: "该卡已绑定过就诊人，请输入其它卡号绑定",
            }).then(() => {
              // this.form.CardNo = "";
            });
          } else {
            this.checkPersonInfo(params);
          }
        });
      }
    },
    checkPersonInfo(params) {
      this.$post("His_PersonInfo", params, {
        alertError: false,
      })
        .then((res) => {
          console.log(1, res);
          if (res.data.mobilePhone) {
            this.form.mobilePhone = res.data.mobilePhone;
            this.showSmsCheck = true;
            this.healthCardResult = res.data;
            this.checkSmsAfterHandleMode = "edit";
          } else {
            this.$notify("未获取到手机号码，无法办理健康卡");
          }
          // debugger;
          // Dialog.confirm({
          //   title: "提示",
          //   message: "您已有本院就诊卡，请绑定就诊卡",
          //   confirmButtonText: "绑定就诊卡",
          //   cancelButtonText: "重新填写信息",
          // }).then(() => {
          //   this.$router.push({
          //     name: "userContactEdit",
          //     query: { ...params, type: this.activeTab + 1 },
          //   });
          // });
        })
        .catch(() => {
          Dialog.confirm({
            title: "提示",
            message: "在输入的信息下未找到可绑定的就诊卡，是否办理一张就诊卡？",
            confirmButtonText: "办理新就诊卡",
            cancelButtonText: "重新填写信息",
          }).then(() => {
            this.$router.push({
              path: "/user/contact/addCard",
              query: params,
            });
          });
        });
    },
    onHealthCardSubmit() {
      if (!this.form.name) {
        this.$notify("请填写真实姓名");
        return;
      }
      if (!this.form.name) {
        this.$notify("请填写身份证号码");
        return;
      }
      const params = {
        name: this.form.name,
        identityNo: this.form.identityNo,
      };
      this.$post("His_PersonInfo", params, {
        alertError: false,
      })
        .then((res) => {
          if (res.data.mobilePhone) {
            this.form.mobilePhone = res.data.mobilePhone;
            this.showSmsCheck = true;
            this.healthCardResult = res.data;
            this.checkSmsAfterHandleMode = "edit";
          } else {
            this.$notify("未获取到手机号码，无法办理健康卡");
          }
          // Dialog.confirm({
          //   title: "提示",
          //   message: "您已有本院就诊卡，请绑定就诊卡",
          //   confirmButtonText: "绑定就诊卡",
          //   cancelButtonText: "重新填写信息",
          // }).then(() => {
          //   this.$router.push({
          //     name: "userContactEdit",
          //     query: { ...params, type: this.activeTab + 1 },
          //   });
          // });
        })
        .catch(() => {
          this.$post("GetPersonInfoFromHealthCard", params, {})
            .then((res) => {
              if (res.data.mobilePhone) {
                this.form.mobilePhone = res.data.mobilePhone;
                this.showSmsCheck = true;
                this.healthCardResult = res.data;
                this.checkSmsAfterHandleMode = "add";
              } else {
                this.$notify("未获取到手机号码，无法办理健康卡");
              }
            })
            .catch((err) => {
              console.log(err);
            });
        });
    },
    onHealthCardConfirmSubmit() {
      if (!this.form.smsCode) {
        this.$notify("请填写短信验证码");
        return;
      }
      // this.$post("CheckMsgCode", {
      //   mobilePhone: this.form.mobilePhone,
      //   codeText: this.form.smsCode,
      // }).then(() => {
      if (this.checkSmsAfterHandleMode == "edit") {
        const params = {
          name: this.form.name,
        };
        if (this.activeTab == 0) {
          params.identityNo = this.form.identityNo;
        } else {
          params.diagnosisCardNo = this.form.cardNo;
        }
        this.$router.push({
          name: "userContactEdit",
          query: { ...params, type: this.activeTab + 1 },
        });
      } else {
        this.$router.push({
          path: "/user/contact/addCard",
          query: {
            ...this.form,
            birthday: this.healthCardResult.birthday,
            sex: this.healthCardResult.sex,
            contactAddress: this.healthCardResult.contactAddress,
            type: "healthCard",
          },
        });
      }
      // });
    },
    getSmsCode() {
      if (!this.form.mobilePhone) {
        this.$notify("请填写手机号码");
        return;
      }
      this.$post("SendMsg", {
        mobilePhone: this.form.mobilePhone,
      }).then(() => {
        this.$toast("验证码发送成功");
        this.smsTimer = 60;
        this.smsTimerInterval = setInterval(() => {
          this.smsTimer--;
          if (this.smsTimer <= 0) {
            clearInterval(this.smsTimerInterval);
          }
        }, 1000);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.mt-header-nav {
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  padding: 10px;
}
.listMenu {
  width: 100%;

  .list {
    width: 100%;
    height: 80px;
    position: relative;
    background-color: #e6e6e6;
    border-radius: 10px;
    margin: 0 0 10px 0;
    font-size: 14px;
    .iconImage {
      position: absolute;
      top: 50%;
      left: 20px;
      transform: translateY(-50%);
      width: 30px;
      height: 30px;
    }
    .words {
      position: absolute;
      top: 50%;
      left: 70px;
      transform: translateY(-50%);
      .tittle {
        color: #000;
        font-weight: bold;
      }
      .describe {
        color: #999;
      }
    }
  }
}

.type-list {
  font-size: 14px;
  padding: 20px;
  .type-item {
    padding: 20px;
    border: 1px solid #ddd;
    text-align: center;
    margin-bottom: 10px;
  }
}
</style>
